import { createRouter as createTanStackRouter } from "@tanstack/react-router"
import { ConvexReactClient } from "convex/react"
import { initSentry } from "#/lib/sentry"
import { routeTree } from "./routeTree.gen"

const convexUrl = import.meta.env.VITE_CONVEX_URL as string

export const convexClient = new ConvexReactClient(convexUrl)

export function getRouter() {
	const router = createTanStackRouter({
		routeTree,
		scrollRestoration: true,
		defaultPreload: "intent",
		defaultPreloadStaleTime: 0,
		context: {
			convexClient,
		},
	})

	initSentry(router)

	return router
}

declare module "@tanstack/react-router" {
	interface Register {
		router: ReturnType<typeof getRouter>
	}
}
